import React, { useState } from 'react';
import { Check, Gift } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function PromoBanner() {
  const {
    t
  } = useLanguage();
  const [isJoined, setIsJoined] = useState(false);
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsJoined(true);
  };
  return <section className="bg-caramel py-16 md:py-20" data-id="element-257" data-mp="my3bosq1dc3g">
      <div className="mx-auto max-w-4xl px-6 text-center md:px-12" data-id="element-258" data-mp="ryhh030967xs">
        <span className="mb-6 inline-flex items-center gap-2 border border-creme/50 px-4 py-1.5 font-sans text-[10px] uppercase tracking-[0.2em] text-creme" data-id="element-259" data-mp="w0vzun3x97p2">
          <Gift size={13} strokeWidth={1.75} aria-hidden="true" data-id="element-260" data-mp="10smev6dt0jmt" />
          {t.promo.badge}
        </span>

        <h2 className="mb-4 font-serif text-2xl leading-snug text-creme md:text-4xl" data-id="element-261" data-mp="15t1r1umcnl37">
          {t.promo.title}
        </h2>
        <p className="mx-auto mb-10 max-w-2xl font-sans font-light text-creme/90" data-id="element-262" data-mp="1fove47xp2wz8">
          {t.promo.text}
        </p>

        {isJoined ? <p className="flex items-center justify-center gap-3 font-serif text-lg italic text-creme" data-id="element-263" data-mp="22c19b5lelwc4">
            <Check size={20} strokeWidth={2} aria-hidden="true" data-id="element-264" data-mp="1xak796r6o3ty" />
            {t.promo.success}
          </p> : <form onSubmit={handleSubmit} className="mx-auto flex max-w-xl flex-col gap-3 sm:flex-row" data-id="element-265" data-mp="1sf4xapwaqs2t">
            <label htmlFor="promo-email" className="sr-only" data-id="element-266" data-mp="2l292ovzax8f4">
              {t.promo.placeholder}
            </label>
            <input id="promo-email" type="email" required placeholder={t.promo.placeholder} className="w-full border border-creme/50 bg-creme/10 px-5 py-3.5 font-sans text-sm text-creme placeholder:text-creme/60 transition-colors focus:border-creme focus:outline-none" data-id="element-267" data-mp="2g3o4t37iv0tu" />
            <button type="submit" className="shrink-0 bg-cacao-900 px-8 py-3.5 font-sans text-xs uppercase tracking-[0.16em] text-creme transition-colors hover:bg-cacao-800" data-id="element-268" data-mp="33u1uwo6jqpls">
              {t.promo.cta}
            </button>
          </form>}
      </div>
    </section>;
}